import RcsAdvManager from '../utils/RcsAdvManager';
import BoxVideo3Col from '../boxes/BoxVideo3Col';
import BoxDDayHP from '../boxes/BoxDDayHP';
import StrisciaBlogHP from '../boxes/StrisciaBlogHP';
import MdBxBottom from '../boxes/MdBxBottom';
import BlogBox from '../boxes/BlogBox';
/* Import RcsUtils from '../utils/RcsUtils';
import DateService from '../utils/DateService';
import RassegnaStampa from '../boxes/RassegnaStampa';
import ExtraPerVoi from '../boxes/ExtraPerVoi'; */

const BASE_PATH = '/includes_methode/cache/';
const ppnSource =
  '//feed.4wnet.com/feed.html.ashx?sl=1&a=4001&n=3&u=REF&i=1&hd=1&f=0&s=Corriere_Home_spc_index_vert&c=//css2.corriereobjects.it/includes2007/static/css/ppn-new-vert-2015.css';

RcsAdvManager.eventHandlers();

/* Function distributeArticles() {
  let hAperturaRight = document.querySelector('.aperturaRight').offsetHeight;
  let hAperturaLeft = document.querySelector('.aperturaLeft').offsetHeight;
  let tolerance = '-365';
  let hZapSum = 280;
  let bianco = Math.abs(hAperturaRight - hAperturaLeft);

  if (document.querySelector('#piaceriWeekEnd') !== null) {
    let piaceriWeekEndArticles = Array.from(
      document.querySelectorAll('#piaceriWeekEnd article')
    );
    piaceriWeekEndArticles.forEach(element => {
      RcsUtils.addClass(element, 'NOCLONE');
    });
  }

  if (document.querySelector('#calciomercato_hp') !== null) {
    let calciomercatoHpArticles = Array.from(
      document.querySelectorAll('#calciomercato_hp article')
    );
    calciomercatoHpArticles.forEach(element => {
      RcsUtils.addClass(element, 'NOCLONE');
    });
  }

  let articleElements = Array.from(
    document.querySelectorAll('#terzacolonna article:not(.NOCLONE)')
  );
  let flag = false;
  articleElements.forEach(element => {
    let hZap = element.offsetHeight;
    let biancoAfterLoad = hAperturaRight - hAperturaLeft - 30;

    if (biancoAfterLoad < tolerance) {
      let diffZapSum = hZapSum;
      hZapSum += hZap;
      if (diffZapSum <= 200) {
        bianco += 350;
      }

      if (diffZapSum < bianco) {
        let clonedElement = element.cloneNode(true);
        let parent = document.querySelector('#terzacolonnaClone');
        parent.appendChild(clonedElement);
        element.parentNode.removeChild(element);
      }
    } else {
      DateService.fetchServerDate(data => {
        let hourNowRassegna = data.hours + data.minutes;
        let biancoRassegna = String(biancoAfterLoad).replace('-', '');
        if (hourNowRassegna >= '0700' && hourNowRassegna < '1400') {
          if (!flag) {
            let rassegnaDimension = '';
            if (biancoRassegna >= 100 && biancoRassegna <= 170) {
              rassegnaDimension = 'box_90';
            } else if (biancoRassegna > 170 && biancoRassegna <= 300) {
              rassegnaDimension = 'box_150';
            } else if (biancoRassegna > 300) {
              rassegnaDimension = 'box_300';
            }
            let rassegnaStampa = new RassegnaStampa({
              urlJson:
                '//xml2.corriereobjects.it/tools/3a-col-nav/tablet_rassegna-stampa.json',
              dimension: rassegnaDimension,
              container: document.querySelector('#terzacolonnaClone')
            });
            rassegnaStampa.render();
            flag = true;
          }
        } else if (hourNowRassegna >= '1400' && hourNowRassegna <= '2100') {
          let dimensionExtraPerVoi = '';
          if (biancoRassegna >= 100 && biancoRassegna <= 170) {
            dimensionExtraPerVoi = '_BOX_NO_FOTO';
          } else if (biancoRassegna > 170 && biancoRassegna <= 300) {
            dimensionExtraPerVoi = '_BOX_FOTO_PICCOLA';
          } else if (biancoRassegna > 300) {
            dimensionExtraPerVoi = '_BOX_FOTO_GRANDE';
          }
          let extraPerVoi = new ExtraPerVoi({
            urlJson:
              '//xml2.corriereobjects.it/tools/3a-col-nav/tablet_extra-per-voi.json',
            dimension: dimensionExtraPerVoi,
            container: document.querySelector('#terzacolonnaClone')
          });
          extraPerVoi.render();
          flag = true;
        }
      });
    }
  });

  RcsUtils.applyLazyLoad();
} */

function adBlockDetected() {
  // DistributeArticles();
  console.log('no distributeArticles: adblock');
}

function checkadBlock() {
  setTimeout(() => {
    let articlesElement = document.querySelector('#terzacolonnaClone article');
    if (
      (typeof fuckAdBlock === 'undefined' || typeof fuckAdBlock === undefined) &&
      articlesElement === null
    ) {
      adBlockDetected();
    } else {
      fuckAdBlock.onDetected(() => adBlockDetected());
      fuckAdBlock.check();
    }
  }, 300);
}

const areas = [
  {
    id: 'HTMLaperturaBottom',
    url: `${BASE_PATH}methode_apertura_bis.shtml`,
    where: document.querySelector('#aperturaBottom'),
    event: 'middleContentLoad'
  },
  {
    id: 'HTMLmiddle',
    url: `${BASE_PATH}middle_load.shtml`,
    where: document.querySelector('div#middle_content'),
    event: 'middleContentLoad',
    init() {
      let blogBox = new BlogBox('');
      blogBox.render();
      RcsAdvManager.render('refreshBottom2');
      RcsAdvManager.render('refreshBottom');
    }
  },
  {
    id: 'HTMLterzacolonna',
    url: `${BASE_PATH}terza_colonna_load_16.shtml`,
    where: document.querySelector('div#terzacolonna'),
    event: 'terzaColonnaLoad',
    init() {
      RcsAdvManager.render('refreshBottom3');

      if (document.querySelector('html.ie9') === null) {
        if (
          typeof rcsOrchestrator !== 'undefined' &&
          rcsOrchestrator.eventManager.isEventTriggered('#document_eventclmnsxresizeDFP')
        ) {
          // DistributeArticles();
          console.log('no distributeArticles');
        } else {
          document.addEventListener(
            'eventclmnsxresizeDFP',
            () => {
              // DistributeArticles();
              console.log('no distributeArticles');
            },
            false
          );
          checkadBlock();
        }
      } else {
        // DistributeArticles();
        console.log('no distributeArticles');
      }
    }
  },
  {
    id: 'HTMLterzacolonna2',
    url: `${BASE_PATH}terza_colonna_load2.shtml`,
    where: document.querySelector('div#terzacolonna2'),
    event: 'terzaColonna2Load',
    init() {
      let boxDDayHp = new BoxDDayHP();
      boxDDayHp.render();
      /* eslint-disable */
      if (
        typeof callReviZoneId === 'function' &&
        typeof PubReviZoneID_HP !== 'undefined'
      ) {
        callReviZoneId(PubReviZoneID_HP);
      }
      /* eslint-enable */
      let urlLocationHref = location.href.split('?')[1];
      if (urlLocationHref === 'refresh_ce') {
        let ppnElement = document.querySelector('.bk_ppn_02');
        if (ppnElement !== null) {
          ppnElement.parentNode.removeChild(ppnElement);
        }
      } else {
        let ppnIframe = document.querySelector('.bk_ppn_02 iframe');
        if (ppnIframe !== null) {
          ppnIframe.setAttribute('src', ppnSource);
        }
      }
    }
  },
  {
    id: 'HTMLbottom',
    url: `${BASE_PATH}bottomPage.shtml`,
    where: document.querySelector('div#row_content'),
    event: 'bottomContentLoad'
  },
  {
    id: 'HTMLbottomrow',
    url: `${BASE_PATH}bottomPageRow.shtml`,
    where: document.querySelector('div#bottom_content'),
    event: 'bottomContentLoad',
    init() {
      let strisciaBlog = new StrisciaBlogHP();
      strisciaBlog.render();

      let mdBxBottom = new MdBxBottom();
      mdBxBottom.render();

      let boxVideo3Col = new BoxVideo3Col();
      boxVideo3Col.render();
    }
  }
];

module.exports = areas;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/areas/desktopAreas.js